import React, { useState, useEffect } from 'react';

const FRACTURED_ATLAS_URL = 'https://fundraising.fracturedatlas.org/aperture-slate-production-slate';
const DONATED_KEY = 'as_supported_slate';

export default function DonationPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Don't show if they've already clicked support this session
    if (sessionStorage.getItem(DONATED_KEY)) return;
    // Slight delay so the tool loads first
    const t = setTimeout(() => setVisible(true), 700);
    return () => clearTimeout(t);
  }, []);

  const handleSupport = () => {
    sessionStorage.setItem(DONATED_KEY, 'true');
    setVisible(false);
    window.open(FRACTURED_ATLAS_URL, '_blank', 'noopener,noreferrer');
  };

  const handleLater = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6"
      style={{ backgroundColor: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(4px)' }}
      onClick={(e) => { if (e.target === e.currentTarget) handleLater(); }}
    >
      <div
        className="w-full max-w-md border border-zinc-700 bg-[#070707] p-10 text-center"
        style={{ fontFamily: 'Inter, system-ui, sans-serif', animation: 'fadeUp 0.3s ease' }}
      >
        <style>{`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(16px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>

        <img src="/logo.png" alt="Aperture Slate" className="h-8 mx-auto mb-6 opacity-60" />

        <p className="text-[11px] tracking-[0.35em] text-sky-400 font-bold uppercase mb-4">
          Support Independent Cinema
        </p>

        <h2 className="text-3xl font-black tracking-tight uppercase leading-tight mb-2 text-white">
          These Tools Are Free.
        </h2>
        <h2 className="text-3xl font-black tracking-tight uppercase leading-tight mb-6 text-zinc-600">
          The Films Need Funding.
        </h2>

        <p className="text-zinc-400 text-sm leading-relaxed mb-8 max-w-sm mx-auto">
          Every tool here exists to help filmmakers succeed. If they're useful to you, consider supporting the Aperture Slate pipeline — a $1M slate of independent films by award-winning filmmaker Michael Kuper.
        </p>

        <div className="space-y-3">
          <button
            onClick={handleSupport}
            className="w-full bg-white text-black text-[11px] font-black tracking-widest uppercase py-4 hover:bg-sky-400 transition-colors duration-200"
          >
            Support the Slate →
          </button>
          <button
            onClick={handleLater}
            className="w-full text-[10px] text-zinc-700 hover:text-zinc-500 tracking-widest uppercase transition-colors py-2"
          >
            Maybe Later
          </button>
        </div>

        <p className="text-[10px] text-zinc-700 mt-6 leading-relaxed">
          Contributions are tax-deductible via Fractured Atlas fiscal sponsorship.
        </p>
      </div>
    </div>
  );
}
